export default __webpack_public_path__ + "static/media/go.91387d79.jpeg";